import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=1fffb9fd&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=1fffb9fd&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fffb9fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fffb9fd')) {
      api.createRecord('1fffb9fd', component.options)
    } else {
      api.reload('1fffb9fd', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=1fffb9fd&scoped=true&", function () {
      api.rerender('1fffb9fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FWoHvvDSwgS7/JS/comp/Paginate.vue"
export default component.exports